/* eslint-disable react/prop-types */
import { Stack } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import TableCommon from "components/TableCommon";
import { useMemo } from "react";
import { usePagination, useSortBy, useTable } from "react-table";

function DataTable({
  table,
  loading,
  filters,
  setFilters,
  query,
  setQuery,
  paginationData,
  setPaginationData,
}) {
  const columns = useMemo(() => table.columns, [table.columns]);
  const data = useMemo(() => table.rows, [table.rows]);

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useSortBy,
    usePagination
  );

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setFilters((prev) => ({ ...prev, searchBy: value }));
  };

  const handleYearChange = (e) => {
    const value = e.target.value;
    setFilters((prev) => ({ ...prev, year: value }));
  };

  const handleApplyFilters = () => {
    setQuery((prev) => ({
      ...prev,
      ...filters,
    }));
    setPaginationData((prev) => ({ ...prev, page: 1 }));
  };

  const handleResetFilters = () => {
    const defaultFilters = {
      year: String(new Date().getFullYear()),
      searchBy: "",
    };
    setFilters(defaultFilters);
    setQuery((prev) => ({
      ...prev,
      ...defaultFilters,
    }));
    setPaginationData((prev) => ({ ...prev, page: 1 }));
  };

  return (
    <SoftBox>
      <SoftBox p={3} display="flex" justifyContent="space-between" alignItems="flex-end" flexWrap="wrap" gap={2}>
        <Stack direction="row" spacing={2} alignItems="flex-end" flexWrap="wrap">
          <SoftBox display="flex" flexDirection="column">
            <SoftTypography component="label" variant="caption" fontWeight="bold" mb={0.5}>
              Năm
            </SoftTypography>
            <SoftInput
              type="number"
              value={filters.year}
              onChange={handleYearChange}
              sx={{ width: "100px" }}
            />
          </SoftBox>
          <SoftBox display="flex" flexDirection="column">
            <SoftTypography component="label" variant="caption" fontWeight="bold" mb={0.5}>
              Tìm kiếm (Mã/Tên TK)
            </SoftTypography>
            <SoftInput
              placeholder="Nhập mã hoặc tên tài khoản..."
              value={filters.searchBy}
              onChange={handleSearchChange}
              sx={{ width: "250px" }}
            />
          </SoftBox>
          <Stack direction="row" spacing={1}>
            <SoftBox
              component="button"
              onClick={handleApplyFilters}
              disabled={loading}
              sx={{
                height: "39px",
                padding: "0 16px",
                borderRadius: 0,
                border: "none",
                backgroundColor: "#1a73e8",
                color: "white",
                cursor: "pointer",
                fontWeight: "bold",
                opacity: loading ? 0.5 : 1,
                "&:hover": { backgroundColor: "#1557b0" },
              }}
            >
              Tải dữ liệu
            </SoftBox>
            <SoftBox
              component="button"
              onClick={handleResetFilters}
              disabled={loading}
              sx={{
                height: "39px",
                padding: "0 16px",
                borderRadius: 0,
                border: "1px solid #d2d6da",
                backgroundColor: "white",
                color: "#344767",
                cursor: "pointer",
                fontWeight: "bold",
                opacity: loading ? 0.5 : 1,
                "&:hover": { backgroundColor: "#f8f9fa" },
              }}
            >
              Reset
            </SoftBox>
          </Stack>
        </Stack>
      </SoftBox>

      <TableCommon
        loading={loading}
        table={table}
        query={query}
        setQuery={setQuery}
        paginationData={paginationData}
        setPaginationData={setPaginationData}
        tableInstance={tableInstance}
      />
    </SoftBox>
  );
}

export default DataTable;
